export const LayerType = {
  NUMBERS: 'numbers',
  FLOW: 'flow',
  LEAD_TIME: 'leadTime',
  NOTES: 'notes',
  CHECKLIST: 'checklist',
  FORECASTING: 'forecasting',
};
